import Api from '@/services/EnvAutoTableAPI'

export default {

  getAutoInfo (info) {
    return Api().post("prod/getautoinfo", info);
  }
}
